import React from 'react';
import { Smartphone, Hand, Zap, Brain } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  tap: Smartphone,
  hand: Hand,
  zap: Zap,
  brain: Brain,
};

export const HowItWorks = () => {
  const { howItWorks } = mockData;

  return (
    <section id="how-it-works" className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4 tracking-tight">
            {howItWorks.title}
          </h2>
          <p className="text-base md:text-lg text-gray-600">{howItWorks.subtitle}</p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {howItWorks.steps.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <div
                key={step.id}
                className="relative group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="bg-white rounded-2xl p-5 md:p-8 shadow-sm hover:shadow-xl transition-all duration-300 h-full border border-gray-100 hover:border-[#2AD7C5]/30 hover:-translate-y-1">
                  {/* Step Number */}
                  <div className="absolute -top-3 -left-3 md:-top-4 md:-left-4 w-7 h-7 md:w-8 md:h-8 bg-[#2AD7C5] text-white rounded-full flex items-center justify-center font-bold text-xs md:text-sm shadow-lg">
                    {step.id}
                  </div>

                  {/* Icon */}
                  <div className="mb-4 md:mb-6">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-[#2AD7C5]/10 rounded-xl flex items-center justify-center group-hover:bg-[#2AD7C5]/20 transition-colors duration-300">
                      <Icon className="text-[#2AD7C5]" size={24} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-base md:text-xl font-semibold text-gray-900 mb-2 md:mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Connector Arrow (hidden on last item and mobile) */}
                {index < howItWorks.steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <div className="w-8 h-0.5 bg-gradient-to-r from-[#2AD7C5] to-transparent"></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
